import React from 'react'

import { menuTab } from '../../../../../../constants/constants'

import useOfficer from './useOfficer'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'

import VerifyDocumentSubmittedWithdrawPage from '../../../page/verifyDocumentSubmittedWithdraw/verifyDocumentSubmittedWithdraw'
import ConfirmSubmittedWithdrawPage from '../../../page/confirmSubmittedWithdraw/confirmSubmittedWithdraw'
import SubmittedWithdrawPage from '../../../page/requestNewProject/submittedWithdraw/submittedWithdraw'

type officerViewProps = ReturnType<typeof useOfficer> & OfficerProps
const OfficerView: React.FC<officerViewProps> = (props) => {
    const { callbackSaveComplete } = props
    const folderAndTabStore = useFolderAndTabStore()

    const renderPage = () => {
        switch (folderAndTabStore?.tabSelected?.id) {
            case menuTab.tab21.id:
            case menuTab.tab25.id:
                return <SubmittedWithdrawPage />
            case menuTab.tab1.id:
                return <VerifyDocumentSubmittedWithdrawPage onSaveComplete={callbackSaveComplete} />
            case menuTab.tabConfirmProjectWithdraw.id:
                return <ConfirmSubmittedWithdrawPage onSaveComplete={callbackSaveComplete} />
            default:
                return <></>
        }
    }
    return renderPage()
}

type OfficerProps = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (status: number, isDraft: boolean) => void
}
const Officer: React.FC<OfficerProps> = (props) => {
    const officerModel = useOfficer()
    return <OfficerView {...officerModel} {...props} />
}

export default Officer
